import React from 'react';
import { observer } from 'mobx-react';
import { action } from 'mobx';
import store from '../../../../stores/store';
//import { userInfo } from 'os';

const ProfileCard = observer(
    class ProfileCard extends React.Component {  
        componentWillMount() {
            var localSwitchData = [];
            store.user.set("profileSwitchData", localSwitchData); 
        }
        componentWillUnmount() {  
            let phone1Switch = this.phone1Switch.checked ? "1" : "0";
            let phone2Switch = this.phone2Switch !== undefined && this.phone2Switch.checked ? "1" : "0";
            let emailAddressSwitch = this.emailAddressSwitch.checked ? "1" : "0";

            if(store.user.profileSwitchData !== null && store.user.profileSwitchData.length > 0) {        
                var localSwitchData = [...store.user.profileSwitchData, phone1Switch  + "," + phone2Switch + "," + emailAddressSwitch];
                store.user.set("profileSwitchData", localSwitchData);                       
            }
            else {
                var localSwitchData = [phone1Switch  + "," + phone2Switch + "," + emailAddressSwitch];
                store.user.set("profileSwitchData", localSwitchData);
            }
        }

        render() {
            const { details } = this.props;

            return (
                <div className="carousel-inner">
                    <div>
                    
                        <table className="table table-sm d-flex justify-content-center">
                            <tbody>
                                <tr>
                                    <th scope="row">Company</th>
                                    <td>{details.Company}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Title</th>
                                    <td>{details.Title}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Phone</th>
                                    <td>{details.Phone1}</td>
                                    {details.Phone1 != null && <td><label className="ios7-switch" >
            <input id="phone1Switch" type="checkbox" ref={el => (this.phone1Switch = el)} checked={details.SharePhone1} onChange={() => this.switched(1)}/>
            <span></span>
        </label></td>}
                                </tr>
                                <tr>
                                    <th scope="row">Mobile</th>
                                    <td>{details.Phone2}</td>
                                    {details.Phone2 != null && <td><label className="ios7-switch" >
            <input id="phone2Switch" type="checkbox" ref={e => (this.phone2Switch = e)} checked={details.SharePhone2}  onChange={() => this.switched(2)}/>
            <span></span>
        </label></td>}
                                </tr>
                                <tr>
                                    <th scope="row">Email</th>
                                    <td>{details.EmailAddress}</td>
                                    {details.EmailAddress != null && <td><label className="ios7-switch" >
            <input id="emailAddressSwitch" type="checkbox"  checked={details.ShareEmailAddress} ref={el => (this.emailAddressSwitch = el)} onChange={() => this.switched(3)}/>
            <span></span>
        </label></td>}
                                </tr>
                                <tr>
                                    <th scope="row">Address</th>
                                    <td>{details.Address1}</td>
                                </tr>
                                <tr>
                                    <th scope="row" />
                                    <td>{details.Address2}</td>
                                </tr>
                                <tr>
                                    <th scope="row">City</th>
                                    <td>{details.Suburb}</td>
                                </tr>
                                <tr>
                                    <th scope="row">State</th>
                                    <td>{details.State}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Post code</th>
                                    <td>{details.PostCode}</td>
                                </tr>
                                <tr>
                                    <th scope="row">Country</th>
                                    <td>{details.Country}</td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                </div>
            );
        }

        switched = (val) => {
            const { details } = this.props
            const profile = {
                instanceid: details.InstanceId,
                firstname: store.user.data.FirstName,
                surname: store.user.data.Surname,
                title: details.Title,
                phone1: details.Phone1,
                phone2: details.Phone2,
                emailaddress: details.EmailAddress,
                address1: details.Address1,
                address2: details.Address2,
                suburb: details.Suburb,
                state: details.State,
                postcode: details.PostCode,
                country: details.Country,
                shouldSharePhone1: this.phone1Switch != null ? this.phone1Switch.checked : null,
                shouldSharePhone2: this.phone2Switch != null ? this.phone2Switch.checked : undefined,
                shouldShareEmailAddress: this.emailAddressSwitch != null ? this.emailAddressSwitch.checked : null
            }
            
            if(val === 1) {
                this.setPhone1CheckBox(details);
            }

            else if(val === 2) {
                this.setPhone2CheckBox(details);
            }
            else if (val === 3) {
                this.setEmailCheckBox(details);
            }

            store.user.updateProfile(profile).then(json => {
                store.user.fetch();
            })
            .catch(e => {
                console.log("error", e)
            })
        }

        setPhone1CheckBox = action('setPhone1CheckBox', details => {         
            if(this.phone1Switch.value === 'on') {               
                details.SharePhone1 = false;
                this.phone1Switch.value = 'off';
            }
            else {
                details.SharePhone1 = true;
                this.phone1Switch.value = 'on';
            }
        });
            
        setPhone2CheckBox = action('setPhone2CheckBox', details => {
            if(this.phone2Switch.value === 'on') {               
                details.SharePhone2     = false;
                this.phone2Switch.value = 'off';
            }
            else {
                details.SharePhone2     = true;
                this.phone2Switch.value = 'on';
            }
        });   
           
        setEmailCheckBox = action('setEmailCheckBox', details => {
            if(this.emailAddressSwitch.value === 'on') {               
                details.ShareEmailAddress     = false;
                this.emailAddressSwitch.value = 'off';
            }
            else {
                details.ShareEmailAddress     = true;
                this.emailAddressSwitch.value = 'on';
            }
        });  
    },
);

export default ProfileCard;



// WEBPACK FOOTER //
// ./src/containers/PrivateArea/Profile/components/ProfileCard.js